import _ from 'lodash';
import React from 'react'
import { Types } from '../types'
import Icons, { IPath } from '../utils/icons'

// Props extended interface
interface IIcon {
  readonly id: string
  readonly type?: 'filled' | 'outlined';
  readonly size?: number
  readonly color?: string
  readonly config: Types.AppConfig
} 
  
/**
 * Icon component to render an Icon based on passed iconId
 * destructured @param id ID of the icon to be rendered
 * destructured @param size Size of the icon to be rendered
 * destructured @param color Color of the icon to be rendered
 * @returns React FC
 */
const Icon: React.FC<IIcon> = ({ id, type = 'filled', size = 1, color, ...props }) => {

  // Icon sizing
  const dimension = size * props?.config.general.sizingBase

  // Icon color
  const fill = color ?? 'currentColor'

  const fillPath = {
    d: 'M36 18C36 27.9411 27.9411 36 18 36C8.05887 36 7.04529e-07 27.9411 1.57361e-06 18C2.44269e-06 8.05887 8.05888 -2.44269e-06 18 -1.57361e-06C27.9411 -7.04529e-07 36 8.05887 36 18Z',
    fillOpacity: '0.07',
  };

  const paths: IPath[] = React.useMemo(() => type === 'filled' ? [...Icons[id].paths, fillPath] : Icons[id].paths, [type]);

  return ( 
    <svg
      width={dimension}
      height={dimension}
      viewBox={`0 0 ${Icons[id].viewDim} ${'viewDimY' in Icons[id] ? Icons[id].viewDimY : Icons[id]?.viewDim}`}
      fill={fill}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      {/* Iterating paths */}
      {paths.map((path, idx) => {
        return (
          // One path markup
          <path
            key={idx}
            d={path.d}
            fill={fill}
            fillOpacity={path.fillOpacity}
          />
        )
      })}
    </svg>
  )
}

export default Icon
